import React from 'react'
import { Form, InputNumber } from 'antd'
import { Perm, State } from '../../../../../../../../constants/assignment-permissions'
import Access from '../../../../../../components/access/Access'
import Text from 'antd/es/typography/Text'

const TestCpuTimeLimit = ({ initialValue }) => {
    return (
        <Form.Item
            label='CPU time limit, sec'
            name='cpuTimeLimit'
            rules={[
                {
                    type: 'number',
                    min: 1,
                    max: 45,
                },
            ]}
            initialValue={5}
        >
            <Access
                rules={[Perm.CAN_EDIT, State.NOT_PROCESSING, State.NOT_MBA, State.UNPUBLISHED]}
                fallback={<Text>{initialValue}</Text>}
            >
                <InputNumber min={1} max={45} />
            </Access>
        </Form.Item>
    )
}

export default TestCpuTimeLimit
